export default __webpack_public_path__ + "static/AdobeStock_349044023_80-376622dfdfd77b017b0898782acaa1c0.jpg";